import { render, staticRenderFns } from "./SearchSlideMenu.vue?vue&type=template&id=2a2a4794&scoped=true&"
import script from "./SearchSlideMenu.vue?vue&type=script&lang=js&"
export * from "./SearchSlideMenu.vue?vue&type=script&lang=js&"
import style0 from "./SearchSlideMenu.vue?vue&type=style&index=0&id=2a2a4794&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2a4794",
  null
  
)

export default component.exports